import { useMutation, useQuery } from "react-query";
import isEmpty from "lodash/isEmpty";
import omit from "lodash/omit";
import reject from "lodash/reject";

import { gwtClient } from "@monta/utils";

import type { QueryKey } from "react-query";
import type { GetExamQuestionsForResultSet } from "./exam-question-result-set.types";

export const getExamQuestionsForResultSet = {
  url: () => `/exam/getExamQuestionsForResultset`,
  fn: async (request: GetExamQuestionsForResultSet["request"]) => {
    const { data } = await gwtClient<GetExamQuestionsForResultSet["response"]>({
      ...request?.axiosConfig,
      method: "POST",
      url: getExamQuestionsForResultSet.url(),
      data: request.body
    });
    return data;
  },
  key: (request: GetExamQuestionsForResultSet["request"]) => {
    return reject(
      [getExamQuestionsForResultSet.url(), omit(request ?? {}, "axiosConfig")],
      isEmpty
    ) as QueryKey;
  },
  query: (options: GetExamQuestionsForResultSet["queryOptions"]) => ({
    ...options.queryOptions,
    keepPreviousData: true,
    queryKey: getExamQuestionsForResultSet.key(options.request),
    queryFn: () => getExamQuestionsForResultSet.fn(options.request)
  }),
  useQuery: (options: GetExamQuestionsForResultSet["queryOptions"]) =>
    useQuery(getExamQuestionsForResultSet.query(options)),
  useMutation: (options?: GetExamQuestionsForResultSet["mutationOptions"]) =>
    useMutation({
      ...options,
      mutationFn: getExamQuestionsForResultSet.fn
    })
};
